import { render, staticRenderFns } from "./ChatDocumentsModal.vue?vue&type=template&id=e4f11c26&scoped=true"
import script from "./ChatDocumentsModal.vue?vue&type=script&lang=js"
export * from "./ChatDocumentsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4f11c26",
  null
  
)

export default component.exports